module.exports = __webpack_public_path__ + "static/media/showcase_ml.04bd0f54.jpg";